<template>
    <v-container class="pt-4 pb-12 py-sm-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Máquinas</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Máquinas',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
               <div class="button-group">
    <v-btn :disabled="dataList.loading" elevation="0" color="primary" outlined dark
        @click="loadData" :loading="dataset.loading">
        <v-icon class="mr-2" size="large">mdi-refresh</v-icon>
        Atualizar
    </v-btn>
</div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
      <v-data-table :headers="visibleHeaders" :items="dataList.data" :server-items-length="dataList.count"
    :disable-sort="true" :loading="dataList.loading" no-data-text="Nenhuma máquina foi encontrada"
    loading-text="Carregando dados..." class="app-table hover-table machine-list-table" hide-default-footer
    :item-class="() => 'row-height-35'">

                    <template v-slot:[`item.name`]="{ item }">
                        {{ item.nome }}
                    </template>

                    <template v-slot:[`item.type`]="{ item }">
                        {{ item.tipo }}
                    </template>

                    <template v-slot:[`item.position`]="{ item }">
                        {{ item.posicao }}
                    </template>

                    <template v-slot:[`item.upbox`]="{ item }">
                        {{ item.upbox ? item.upbox.identificador : '' }}
                    </template>

                    <template v-slot:[`item.blockTime`]="{ item }">
                        {{ item.tempoBloqueioMaquina }}min
                    </template>

                    <template v-slot:[`item.value`]="{ item }">
                        R$ {{ item.valor | currency }}
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <span :class="item.habilitada ? 'green--text' : 'error--text'">
                            <strong>{{ item.habilitada ? "Habilitada" : "Desabilitada" }}</strong>
                        </span>
                    </template>

                    <template v-slot:[`item.statusMaquina`]="{ item }">
                        <span>
                            <v-icon class="mr-2" x-small
                                :color="getColorByUpboxStatus(item.statusMaquina)">mdi-circle</v-icon>
                            {{ item.statusMaquina || 'N/A' }}
                        </span>
                    </template>

<template v-slot:[`item.pulsos`]="{ item }">
  <v-btn :disabled="dataList.loading" elevation="2"
    style="background-color: #f44336 !important; color: white !important;"
    @click="sendPulse(item)" small class="action-btn-fixed">
    Env. Pulso
  </v-btn>
</template>

<template v-slot:[`item.actions`]="{ item }">
  <v-btn :disabled="dataList.loading" color="primary-200"
    @click="viewItem(item)" small class="action-btn-fixed">
    <v-icon left>mdi-pencil-outline</v-icon>
    Editar
  </v-btn>
</template>

                </v-data-table>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

import { eventHub } from "@/main"

Vue.use(VueLodash)

export default {
    name: "MachineList",

    data: () => ({
        dataset: {
            data: {},
            operation: null
        },
        dataList: {
            filter: {
                name: "",
            },
headers: [
    { text: "Nome", value: "name" },
    { text: "Tipo", value: "type" },
    { text: "Valor", value: "value" },
    { text: "Tempo de bloqueio", value: "blockTime", hideOnMedium: true },
    { text: "Posição", value: "position", hideOnMedium: true },
    { text: "Upbox", value: "upbox", hideOnMedium: true },
    { text: "Situação", value: "status" },
    { text: "Status", value: "statusMaquina" },
       { text: "Pulso", value: "pulsos", sortable: false, align: 'center', width: 130 },
    { text: 'Ações', value: 'actions', sortable: false, align: 'center', width: 130 },
],
            data: [],
            loading: false,
            count: 0,
        },
    }),

    computed: {
        // Colunas menos essenciais (Tempo de bloqueio, Posição, Upbox) somem em
        // telas menores (ex: notebooks 1024x768) pra tabela não precisar de
        // scroll horizontal pra ver Situação/Status/Ações.
        visibleHeaders() {
            const isMediumOrSmaller = this.$vuetify.breakpoint.width < 1264;
            return this.dataList.headers.filter((h) => !(isMediumOrSmaller && h.hideOnMedium));
        },
    },

    mounted() {
        eventHub.$on('CHANGE-OPERATION', (value) => {
            this.getSelectedOperation();
            this.loadData()
        })

        this.getSelectedOperation();

        if (!this.dataset.operation) {
            this.$dialog.notify.error('Nenhuma operação selecionada!', { position: 'top-right', timeout: 5000 });
            return;
        }

        this.loadData();
    },

    destroyed() {
        eventHub.$off('CHANGE-OPERATION')
    },

    methods: {

        getColorByUpboxStatus(status) {
            if (!status) return 'mediumGray';

            switch (status.toLowerCase()) {
                case 'livre':
                    return 'green'
                case 'offline':
                    return 'error'
                case 'ocupada':
                    return 'amber'
                default:
                    return 'error'
            }
        },

        getSelectedOperation() {
            this.dataset.operation = localStorage.getItem('operation');
        },

        loadData() {
            this.load()
        },

        async load() {
            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/maquina', {
                    params: { operacaoId: this.dataset.operation }
                });

                this.dataList.data = result.data;
                this.dataList.count = this.dataList.data.length;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

             async sendPulse(item) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar o pulso para a máquina <strong>${item.nome}</strong>?`,
                title: 'Pulso',
                actions: {
                    false: 'Cancelar',
                    true: { text: 'Enviar', color: 'primary' }
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true;

            try {
                await axios.post(`/api/maquina/${item.id}/enviar-pulso`, {});

                this.$dialog.notify.info("Pulso enviado com sucesso", { position: "top-right", timeout: 2000 });

                await new Promise(resolve => setTimeout(resolve, 1000));

                this.load();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataList.loading = false;
            }
        },

        async testRequest() {
            const result = await axios.post('https://demo6718810.mockable.io/test-error');
        },

        viewItem(item) {
            this.$router.push(`maquinas/${item.id}`);
        },

    },
};
</script>

<style>
.actions-row {
    gap: 4px;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.action-btn-fixed {
  width: 100px;
}

.app-table.machine-list-table td:nth-last-child(2),
.app-table.machine-list-table td:nth-last-child(1) {
  padding-left: 1px !important;
  padding-right: 1px !important;
}

/* Reduz exclusivamente o recuo esquerdo nas telas mobile para encostar mais na borda, sem mexer nos valores */
/* padding/min-height do modo mobile do .app-table agora é global (assets/scss/main.scss) */
@media (max-width: 768px) {
  .app-table.machine-list-table .v-data-table__mobile-row {
    padding-left: 2px !important;
    padding-right: 2px !important; /* empurra os valores mais pra direita */
  }
}

@media (max-width: 600px) {
  .title-container {
    flex-wrap: wrap;
  }

  .button-group {
    width: 100%;
    margin-top: 25px;
  }

  .button-group .v-btn {
    width: 100%;
    min-width: unset;
  }
}

@media (max-width: 768px) {
  .app-table.machine-list-table.v-data-table--mobile tr > .v-data-table__mobile-row:nth-child(10) {
    display: none !important;
  }
  .app-table.machine-list-table.v-data-table--mobile tr > .v-data-table__mobile-row:nth-child(9) .v-data-table__mobile-row__header::after {
    content: "Pulso/Ações";
  }
  .app-table.machine-list-table.v-data-table--mobile tr > .v-data-table__mobile-row:nth-child(9) .v-data-table__mobile-row__header {
    font-size: 0 !important;
  }
  .app-table.machine-list-table.v-data-table--mobile tr > .v-data-table__mobile-row:nth-child(9) .v-data-table__mobile-row__header::after {
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    color: #333;
  }
}

/* borda/espaçamento entre linhas do modo mobile do .app-table agora é global (assets/scss/main.scss) */
</style>